import Highcharts from "highcharts";
import { chartConfig } from "../chart.commonConfig";
import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";
import { isEmpty } from "lodash";

export const PROJECT_STAGE_WISE_RESPONSIVE_CHART_HELPER = data => {
  const BAR_CHART_CONFIG = {
    chart: {
      ...chartConfig.chart,
      zoomType: "xy",
      renderTo: "bar-chart",
      className: "chart-background",
      height: (12 / 16) * 100 + "%",
      animation: {
        duration: 9000
      },
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.FIRST_PAGE.FIRST._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      text: ""
    },
    xAxis: [
      {
        categories: [],
        className: "bar-label",
        lineWidth: 1,
        lineColor: "#2d79d3",
        tickColor: "#2d79d3",
        tickPosition: "inside",
        tickLength: 5,
        alignTicks: true,
        labels: {
          enabled: false,
          autoRotation: [-90],
          formatter: function() {
            return this.value;
          },
          style: {
            "font-weight": "300",
            "font-size": "10px",
            //width: "75px",
            color: "black"
          }
        }
      }
    ],
    yAxis: [
      {
        className: "bar-label",
        lineWidth: 1,
        lineColor: "#2d79d3",
        alignTicks: true,
        labels: {
          format: `{value}`,
          style: {
            "font-weight": "300",
            color: "black",
            "font-size": "10px"
          }
        },
        title: {
          text: "Number of Issues(s)",
          style: {
            color: "black",
            "font-size": "11px"
          }
          //margin: 20
        },
        allowDecimals: false,
        gridLineColor: "#e7f1fb"
      }
    ],
    tooltip: {
      shared: true,
      pointFormat: `Issues: <b>{point.y}</b><br/>`
    },
    series: [
      {
        name: "Project Stages",
        type: "column",
        yAxis: 0,
        zIndex: 1,
        data: [],
        dataLabels: {
          allowOverlap: true,
          enabled: true,
          style: {
            textOutline: "none"
          }
        },
        color: "#2d79d3"
      }
    ],
    plotOptions: {
      series: {
        animation: true,
        events: {
          legendItemClick: function(event) {
            event.preventDefault();
          }
        }
      },
      column: {
        // pointWidth: 30
      }
    },
    legend: {
      symbolWidth: 0,
      symbolHeight: 0,
      squareSymbol: false,
      itemStyle: {
        fontSize: "11px"
      }
    }
  };

  // extract data for charts
  const barChartdata = { bucket: [], count: [] };
  if (!isEmpty(data)) {
    data.bucketCountDTOList.forEach(({ bucket, count }) => {
      barChartdata.bucket.push(bucket);
      barChartdata.count.push(count);
    });
  }

  BAR_CHART_CONFIG.xAxis[0].categories = barChartdata.bucket;
  BAR_CHART_CONFIG.series[0].data = barChartdata.count;
  BAR_CHART_CONFIG.yAxis[0].max = Math.max(...barChartdata.count);
  BAR_CHART_CONFIG.yAxis[0].tickAmount = 6;

  return BAR_CHART_CONFIG;
};
